import moment from 'moment'
/**
 * Format date to DD/MM/YYYY, function called by List Courses and ModalCourse
 * @param {string} date
 */
export function formatDate(date) {
  moment.locale()
  return moment(date).format('DD/MM/YYYY')
}
